export enum UpdateEmailStep {
  ConfirmPassword = 'Password',
  NewEmail = 'New Email',
  ConfirmationCode = 'Confirmation Code',
}
